import { render, staticRenderFns } from "./SeeYa.vue?vue&type=template&id=248b6851&"
import script from "./SeeYa.vue?vue&type=script&lang=ts&"
export * from "./SeeYa.vue?vue&type=script&lang=ts&"
import style0 from "./SeeYa.vue?vue&type=style&index=0&id=248b6851&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports